import ClockInPlace from './ClockInPlace';
export default ClockInPlace;
